import * as constants from '../constants';

export default function (state = "allar umferðir", action) {
  switch (action.type) {
    case constants.UMFERD:
      return action.payload
    default: return state;
  };
};